import { useEffect, useState } from 'react';
import { fetchAdDataFreshness } from '../api/adDataFreshness';

type FreshnessState = { key: string; status: 'loading' | 'ready' | 'unavailable'; updatedAt: string };
export function useAdDataFreshness(brandId: string, siteId: string, platform: string, enabled: boolean, reportLoading: boolean) {
  const key = [brandId, siteId, platform].join(':');
  const [state, setState] = useState<FreshnessState>({ key: '', status: 'loading', updatedAt: '' });
  useEffect(() => {
    if (!enabled || reportLoading) return;
    const controller = new AbortController();
    setState({ key, status: 'loading', updatedAt: '' });
    fetchAdDataFreshness({ brand_id: brandId, site_id: siteId, platform }, controller.signal)
      .then(data => {
        if (!controller.signal.aborted) setState({ key, status: data.supported && data.updated_at ? 'ready' : 'unavailable', updatedAt: data.updated_at });
      })
      .catch(() => {
        if (!controller.signal.aborted) setState({ key, status: 'unavailable', updatedAt: '' });
      });
    return () => controller.abort();
  }, [key, brandId, siteId, platform, enabled, reportLoading]);
  // Never show a timestamp from the previous site or platform while switching.
  return state.key === key && !reportLoading ? state : { key, status: 'loading' as const, updatedAt: '' };
}
